import times from 'lodash/times';
import { Fragment } from 'react';
import ContentLoader from 'react-content-loader';
import { contentLoaderConfig } from '../../constants/common';
import useResolvedColorScheme from '../../hooks/useResolvedColorScheme';

interface LiveEventLoaderProps {
	className?: string;
	isMiniLoader?: boolean;
}

export const LiveEventLoader = (props: LiveEventLoaderProps) => {
	const skeletonRows = props.isMiniLoader ? 1 : 7;
	const { resolvedColorScheme } = useResolvedColorScheme();
	const contentLoaderColor = resolvedColorScheme === 'dark' ? contentLoaderConfig.backgroundColor.dark : contentLoaderConfig.backgroundColor.light;
	return (
		<ContentLoader
			className={props.className}
			width="100%"
			height={props.isMiniLoader ? 280 : '100vh'}
			backgroundColor={contentLoaderColor}
			foregroundColor={contentLoaderColor}
		>
			<rect x="0" y="17" rx="5" ry="5" width="47" height="29" />
			<rect x="80" y="23" rx="5" ry="5" width="50%" height="16" />
			<rect x="80%" y="23" rx="5" ry="5" width="20%" height="16" />
			{times(20).map((_, index) => (
				<Fragment key={index}>
					<rect y="65" x={index * 70} rx="20" ry="20" width="60" height="40" />
				</Fragment>
			))}

			{times(skeletonRows).map((_, index) => (
				<Fragment key={index}>
					<rect x="0%" y={124 + index * 90} rx="4" ry="4" width="31.11%" height="68" />
					<rect x="34.44%" y={124 + index * 90} rx="4" ry="4" width="31.11%" height="68" />
					<rect x="68.88%" y={124 + index * 90} rx="4" ry="4" width="31.11%" height="68" />
				</Fragment>
			))}
			<rect x="37%" y={props.isMiniLoader ? 222 : 762} rx="0" ry="0" width="25%" height="45" />
		</ContentLoader>
	);
};
